module.exports = __webpack_public_path__ + "img/ic_qu_next_off.b8eb618a.svg";